import * as yup from 'yup';
import { error } from './text';

const requiredValidation = yup.string().required(error.required);

const imageValidation = yup
  .mixed<File>()
  .test('fileFormat', error.image, value => {
    if (value instanceof File) {
      const supportedFormats = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'svg'];
      const fileExtension = value.name.split('.').pop()?.toLowerCase();
      return supportedFormats.includes(fileExtension || '');
    }
    return true;
  })
  .test('fileSize', error.imageSize, value => {
    if (value instanceof File) {
      return value.size <= 10 * 1024 * 1024; // 10MB以下
    }
    return true;
  });

const hasLetterAndNumberAndSymbol = /(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!-/:-@[-`{-~])/;
const hasLetterAndNumber = /(?=.*[a-zA-Z])(?=.*[0-9])/;
const hasLetterAndSymbol = /(?=.*[a-zA-Z])(?=.*[!-/:-@[-`{-~])/;
const hasNumberAndSymbol = /(?=.*[0-9])(?=.*[!-/:-@[-`{-~])/;
const combinedRegex = new RegExp(
  `${hasLetterAndNumberAndSymbol.source}|` +
    `${hasLetterAndNumber.source}|` +
    `${hasLetterAndSymbol.source}|` +
    `${hasNumberAndSymbol.source}`,
);

export const passwordValidataion = yup
  .string()
  .required(error.required)
  .min(6, error.min)
  .matches(combinedRegex, error.mixed)
  .max(250, error.below250);

export const passwordConfirmValidation = yup
  .string()
  .required(error.required)
  .test('passwordMatch', error.passwordMatch, function (value) {
    if (value && value !== this.resolve(yup.ref('password'))) {
      return false;
    }
    return true;
  });

export const StaffRegisterSchema = yup.object().shape({
  department: requiredValidation.max(250, error.below250),
  icon: imageValidation,
  email: yup.string().nullable(),
  name: requiredValidation.max(250, error.below250),
  password: passwordValidataion,
  passwordConfirm: passwordConfirmValidation,
});

export const clientStaffEditSchema = yup.object().shape({
  department: yup.string().nullable().required(error.required).max(250, error.below250),
  iconId: yup.string().nullable(),
  icon: imageValidation,
  email: yup.string().nullable(),
  name: requiredValidation.max(250, error.below250),
  role: yup.bool().oneOf([true, false], error.required).required(error.required),
  daily_limit: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .min(1, '1以上の数値を入力してください')
    .integer('整数を入力してください'),
});
